import Vue from "vue";
import { Ability } from "@casl/ability";
import axios from "./../axios"
import router from './../router'
export default function defineAbilitiesFor() {
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  let roleId = userInfo["roleId"];
    return axios.get(`/api/roles/${roleId}`)
        .then(response => {
          let rolePermission = response.data['role_permission']
          var readResult = rolePermission.map(function(obj) {
            let readobj = {};
            if (obj.read) {
              readobj = { subject: obj.name, action: "read" };
            }
            return readobj;
          });
          readResult = readResult.filter(value => Object.keys(value).length !== 0);
      
          var writeResult = rolePermission.map(function(obj) {
            let writeobj = {};
            if (obj.create) {
              writeobj = { subject: obj.name, action: "create" };
            }
            return writeobj;
          });
          writeResult = writeResult.filter(
            value => Object.keys(value).length !== 0
          );
      
          var updateResult = rolePermission.map(function(obj) {
            let updateobj = {};
            if (obj.update) {
              updateobj = { subject: obj.name, action: "update" };
            }
            return updateobj;
          });
          updateResult = updateResult.filter(
            value => Object.keys(value).length !== 0
          );
      
          var deleteResult = rolePermission.map(function(obj) {
            let deleteobj = {};
            if (obj.delete) {
              deleteobj = { subject: obj.name, action: "delete" };
            }
            return deleteobj;
          });
          deleteResult = deleteResult.filter(
            value => Object.keys(value).length !== 0
          );
          Array.prototype.push.apply(readResult, writeResult, updateResult);
          Array.prototype.push.apply(readResult, updateResult);
          Array.prototype.push.apply(readResult, deleteResult);
          
          // var profile_data = {subject: "profile",action: "read"}
          // if (!readResult.find(o => o.subject === 'profile' && o.action === 'read')){
          //   readResult.push(profile_data)
          // }
          // console.log(readResult)
          return new Ability(readResult);
                }).catch(err => {
                  if (err.response.status === 401) {
                    router.push({
                      path: '/login'
                      })
         }
             });
  }




